export const TEST_IDS = {
  dcbOperatorDropdownItem: 'dcb-operator-dropdown-item',
  ccFormSubmitButton: 'cc-form-submit-button',
  ccFormEmailInput: 'cc-form-email-input',
  submitOtpButton: 'submit-otp-button',
  otpInput: 'otp-input',
} as const;
